<script setup lang="ts">
import ListEmpty from "@/components/ui/ComplexList/ListEmpty.vue";
import LoadingIndicator from "@/components/ui/LoadingIndicator.vue";
</script>

<template>
  <ListEmpty tabindex="-1" aria-live="polite" class="loading-state">
    <LoadingIndicator />
    <span>{{ $t("issueSelector.loading") }}</span>
  </ListEmpty>
</template>

<style lang="scss" scoped>
.loading-state {
  :deep(.empty-text) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
}
</style>
